"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EwelinkCallbackPage = EwelinkCallbackPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var loader_1 = require("../components/loader");
var button_component_1 = require("../components/ui/button-component");
var text_component_1 = require("../components/ui/text-component");
var routes_1 = require("../constants/routes");
var ewelink_1 = require("../features/apis/ewelink");
var api_error_message_1 = require("../utils/api-error-message");
var client_scoped_query_1 = require("../utils/client-scoped-query");
// eWeLink sends the user back here after they approve access; this page hands the code to the API.
function EwelinkCallbackPage() {
    var REGIONS = ["eu", "us", "as", "cn"];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var _a = (0, react_1.useState)(""), error = _a[0], setError = _a[1];
    var completeEwelinkConnect = (0, ewelink_1.useCompleteEwelinkConnectMutation)()[0];
    // The code is single use, so the exchange must run once even if the effect runs twice.
    var hasStartedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (hasStartedRef.current || !clientId) {
            return;
        }
        hasStartedRef.current = true;
        var code = searchParams.get("code");
        var state = searchParams.get("state");
        var region = searchParams.get("region");
        if (!code || !state) {
            setError("eWeLink sign-in was cancelled or didn't finish. Try connecting again.");
            return;
        }
        if (!region || !REGIONS.includes(region)) {
            setError("eWeLink didn't say which region your account is in. Try connecting again.");
            return;
        }
        completeEwelinkConnect({ code: code, state: state, region: region, clientId: clientId })
            .unwrap()
            .then(function () { return navigate(routes_1.ROUTES.INTEGRATIONS, { replace: true }); })
            .catch(function (completeError) { return setError((0, api_error_message_1.getApiErrorMessage)(completeError, "Unable to connect eWeLink. Please try again.")); });
    }, [clientId]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col items-center gap-4 py-16 text-center", children: error ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", weight: "bold", color: "dark-gray-1", label: "eWeLink wasn't connected" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: error }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Back to Integrations", onPress: function () { return navigate(routes_1.ROUTES.INTEGRATIONS, { replace: true }); } })] })) : ((0, jsx_runtime_1.jsx)(loader_1.Loader, { variant: "inline", size: "md", label: "Connecting eWeLink\u2026" })) }));
}
